import { motion } from 'framer-motion';
import styles from './Footer.module.css';

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.glowEffect} />
      
      <div className={styles.footerContent}>
        <motion.div 
          className={styles.brandSection}
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className={styles.brandName}>SFRays</h2>
          <p className={styles.brandTagline}>
            Transforming ideas into exceptional digital experiences
          </p>
          <p className={styles.brandDescription}>
            We partner with forward-thinking businesses to create innovative solutions 
            that drive growth and make a lasting impact.
          </p>
        </motion.div>

        <div className={styles.linksGrid}>
          <motion.div 
            className={styles.linkColumn}
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h3 className={styles.linkTitle}>Services</h3>
            <ul className={styles.linkList}>
              <li><a href="#" className={styles.link}>Web Development</a></li>
              <li><a href="#" className={styles.link}>Mobile Apps</a></li>
              <li><a href="#" className={styles.link}>Cloud Solutions</a></li>
              <li><a href="#" className={styles.link}>Consulting</a></li>
            </ul>
          </motion.div>

          <motion.div 
            className={styles.linkColumn}
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h3 className={styles.linkTitle}>Company</h3>
            <ul className={styles.linkList}>
              <li><a href="#" className={styles.link}>About Us</a></li>
              <li><a href="#" className={styles.link}>Our Work</a></li>
              <li><a href="#" className={styles.link}>Careers</a></li>
              <li><a href="#" className={styles.link}>Blog</a></li>
            </ul>
          </motion.div>

          <motion.div 
            className={styles.linkColumn}
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <h3 className={styles.linkTitle}>Connect</h3>
            <ul className={styles.linkList}>
              <li><a href="#" className={styles.link}>Twitter</a></li>
              <li><a href="#" className={styles.link}>LinkedIn</a></li>
              <li><a href="#" className={styles.link}>Instagram</a></li>
              <li><a href="#" className={styles.link}>GitHub</a></li>
            </ul>
          </motion.div>
        </div>
      </div>

      <div className={styles.footerBottom}>
        <p className={styles.copyright}>
          © {new Date().getFullYear()} SFRays. All rights reserved.
        </p>
        <div className={styles.legalLinks}>
          <a href="#" className={styles.legalLink}>Privacy Policy</a>
          <span className={styles.separator}>•</span>
          <a href="#" className={styles.legalLink}>Terms of Service</a>
        </div>
      </div>
    </footer>
  );
}
